export enum EZipCodeValidation {
  fiveDigits = 0,
  fourDigits = 1,
  fourDigitsTwoLetters = 2,
}
